module.exports = __webpack_public_path__ + "static/media/time-session-60.78805b69.svg";